import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import Todo from "./Todo";

export default function TodoList() {
  const todos = useSelector((state) => state.todos);
  const dispatch = useDispatch();
  console.log(todos);
  useEffect(() => {
    dispatch(fetchTodos);
  }, [dispatch]);

  const filterByCompleted = (todo) => {
    return todo.completed === true;
  };

  return (
    <div className="mt-10 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {todos.filter(filterByCompleted).map((todo) => (
        <Todo todo={todo} key={todo.id} />
      ))}
    </div>
  );
}
